import z from "zod";
import { OrganizationIdSchema } from "./idTypes";
import { EntitlementSchema, RoleNameSchema } from "./userContextTypes";

// One reachable tenant in GET /tenants. Entitlements ride per-tenant (not on
// /context) so feature-gate and quota UI can read plan capabilities without
// an extra round-trip.
//
// `isPrimary` identifies the registrar-seeded bootstrap tenant created at
// sign-up. Distinct from role-based ownership: a user can hold `role.owner`
// in many tenants, but exactly one row per user is primary and it can't be
// reassigned.
export const TenantSummarySchema = z.object({
  tenantId: OrganizationIdSchema,
  tenantName: z.string().optional(),
  organizationId: OrganizationIdSchema,
  organizationName: z.string().optional(),
  entitlements: z.array(EntitlementSchema),
  isPrimary: z.boolean(),
  organizationRole: RoleNameSchema.optional(),
  // Only sent when the caller holds an org role; absent on a tenancy reached
  // through a project grant alone, and when the org records no owner.
  organizationOwnerEmail: z.string().optional(),
});
export type TenantSummary = z.infer<typeof TenantSummarySchema>;

export const TenantsResponseSchema = z.object({
  tenants: z.array(TenantSummarySchema),
});
